export const site_url = 'https://bar-sunnyspot.com/blog/'; // WordPress本体
export const about_page_url = site_url + 'wp-json/wp/v2/pages/2?_embed'; // 固定ページのID2を取得
export const menu_page_url = site_url + 'wp-json/wp/v2/pages/12?_embed'; // 固定ページのID12を取得
export const privacy_policy_page_url = site_url + 'wp-json/wp/v2/pages/68?_embed'; // 固定ページのID12を取得
export const information_page_url = site_url + 'wp-json/wp/v2/pages/15?_embed'; // 固定ページのID15を取得
export const post_url = site_url + 'wp-json/wp/v2/posts/'; // 投稿を取得する
export const posts_url = site_url + 'wp-json/wp/v2/posts/?_embed'; // 投稿一覧を取得
//_embedのパラメータを付与するのは、記事に設定されているサムネイル画像を取得するため
